'use client';

import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer className="bg-brand-plum text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <AppImage
              src="/assets/images/Lone_Star_Local_Full_Color-1771711306028.png"
              alt="The Lone Star Local logo"
              width={250}
              height={100}
              className="w-64 h-auto mb-4"
            />
            <p className="font-body text-white/80">
              Boutique. Selective. Grounded.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-body font-semibold text-lg mb-4">Navigation</h4>
            <nav className="space-y-2">
              <Link href="/homepage" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Home
              </Link>
              <Link href="/portfolio" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Work
              </Link>
              <Link href="/services" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Services
              </Link>
              <Link href="/about" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                About
              </Link>
              <Link href="/contact" className="block font-body text-white/80 hover:text-brand-teal transition-smooth">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body font-semibold text-lg mb-4">Get in Touch</h4>
            <p className="font-body text-white/80 mb-2">
              Based in Dallas, Texas
            </p>
            <p className="font-body text-white/80 mb-4">
              hello@lonestarlocal.com
            </p>
            
            {/* Social Media Links */}
            <div className="flex gap-4 mt-4">
              <a
                href="https://www.facebook.com/thelonestarlocal"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-brand-teal transition-smooth"
                aria-label="Facebook"
              >
                <Icon name="facebook" size={24} />
              </a>
              <a
                href="https://www.instagram.com/lonestar.local/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-brand-teal transition-smooth"
                aria-label="Instagram"
              >
                <Icon name="instagram" size={24} />
              </a>
              <a
                href="https://www.tiktok.com/@thelonestarlocal"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-brand-teal transition-smooth"
                aria-label="TikTok"
              >
                <Icon name="tiktok" size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="font-body text-white/70">
            © {new Date()?.getFullYear()} The Lone Star Local. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}